// This function accepts a React ref and checks to see if a library
// has already been lazy loaded. If the lazyload class does NOT exist
// on the component, then this function will return true
export const shouldReloadWidget = ref =>
  ref && !ref.className.includes("lazyload")
